"use client";

import { forgotPasswordAction, ForgotPasswordActionState } from "@/entities/auth";
import { Button, Input, Label } from "@pandawa-qfast-core/react-ui-kit";
import { AlertCircleIcon, ArrowLeftIcon, CheckCircleIcon, LoaderIcon, MailIcon } from "lucide-react";
import Link from "next/link";
import { useActionState } from "react";

const forgotPasswordActionInitialState: ForgotPasswordActionState = {
  success: false,
  message: "",
  errors: {},
  fields: {
    email: "",
  },
};

export function ForgotPasswordForm() {
  const [state, formAction, pending] = useActionState(forgotPasswordAction, forgotPasswordActionInitialState);

  return (
    <div>
      <Link
        href="/"
        className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors mb-6"
      >
        <ArrowLeftIcon className="h-4 w-4" />
        Kembali ke login
      </Link>

      {state.success ? (
        <div className="space-y-5 fade-in-top">
          <div className="bg-green-50 border border-green-200 text-green-700 px-5 py-6 rounded-xl text-center">
            <CheckCircleIcon className="h-12 w-12 mx-auto mb-3 text-green-500" />
            <h3 className="font-semibold text-lg mb-2">Email Terkirim!</h3>
            <p className="text-sm">{state.message}</p>
          </div>

          <Button asChild variant="outline" className="w-full h-11 font-bold">
            <Link href="/">Kembali ke Login</Link>
          </Button>
        </div>
      ) : (
        <form action={formAction} className="space-y-5">
          {state.message && !state.success && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm flex items-start gap-2.5 fade-in-top">
              <AlertCircleIcon className="h-5 w-5 mt-0.5 flex-shrink-0 text-red-400" />
              <span>{state.message}</span>
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="email" className="text-sm font-medium text-foreground">
              Email
            </Label>
            <div className="relative">
              <MailIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
              <Input
                id="email"
                name="email"
                type="email"
                placeholder="nama@email.com"
                disabled={pending}
                defaultValue={state.fields?.email}
                className="pl-10 h-11"
              />
            </div>
            {state.errors?.email?.[0] && <p className="text-xs text-red-500 mt-1">{state.errors.email[0]}</p>}
          </div>

          <Button
            type="submit"
            className="w-full h-11 font-bold text-sm bg-primary hover:bg-primary-600 transition-colors shadow-sm"
            disabled={pending}
          >
            {pending ? (
              <>
                <LoaderIcon className="mr-2 h-4 w-4 animate-spin" />
                Mengirim...
              </>
            ) : (
              "Kirim Link Reset Password"
            )}
          </Button>
        </form>
      )}
    </div>
  );
}
